import React from "react";
import { VideoDialog } from "../../components";

const VideoFaqDialog = ({ videoFaq, onClose }) => (
  <VideoDialog videoUrl={videoFaq.videoUrl} title={videoFaq.topic} onClose={onClose} />
);

export default VideoFaqDialog;
